import type { Money, Ratio } from '@taler/domain'

export type { LentTo, LentToItem, LentToTarget } from '@taler/api-client'

export interface DonutSlice {
  readonly key: string
  readonly label: string
  readonly amount: Money
  readonly share: Ratio | undefined
  /** A `--color-series-N` custom property, never a literal colour. */
  readonly colour: string
}

export interface TopListRow {
  readonly key: string
  readonly label: string
  readonly icon: string | undefined
  readonly amount: Money
  readonly share: Ratio | undefined
}

export interface BreakdownRow {
  readonly key: string
  readonly label: string
  readonly icon: string | undefined
  readonly entryCount: number
  readonly amount: Money
  readonly share: Ratio | undefined
}

export interface LargestTransactionRow {
  readonly key: string
  readonly entryId: string
  readonly date: string
  readonly payee: string
  readonly category: string
  readonly categoryIcon: string | undefined
  readonly account: string
  readonly amount: Money
  readonly tags: readonly string[]
}

export interface AccountFlowRow {
  readonly key: string
  readonly label: string
  readonly icon: string | undefined
  readonly count: number
  readonly inflow: Money
  readonly outflow: Money
  readonly transfersIn: Money
  readonly transfersOut: Money
  readonly net: Money
}

/** Categorical chart colours, named literally so the Tailwind theme scan keeps every series token. */
export const SERIES_COLOURS = [
  'var(--color-series-1)',
  'var(--color-series-2)',
  'var(--color-series-3)',
  'var(--color-series-4)',
  'var(--color-series-5)',
  'var(--color-series-6)',
  'var(--color-series-7)',
] as const
